import styled, { css } from "styled-components";

export const TextareaOutput = styled.div`
    white-space: pre-line;
`;
